if (!customElements.get('site-credits-bar')) {
  customElements.define('site-credits-bar', class SiteCreditsBar extends HTMLElement {
    connectedCallback() {
      this._isOpen = false;
      this._currentAnim = null;

      // Scope trigger lookup to this section — safe if multiple instances exist
      this._trigger = this.closest('section')?.querySelector('[data-credits-trigger]');
      this._closeBtn = this.querySelector('[data-credits-close]');

      this._onTriggerClick = () => this.open();
      this._onCloseClick = () => this.close();
      this._onDocumentClick = (e) => {
        if (!this.contains(e.target)) this.close();
      };

      this._trigger?.addEventListener('click', this._onTriggerClick);
      this._closeBtn?.addEventListener('click', this._onCloseClick);
    }

    open() {
      if (this._isOpen) return;
      this._isOpen = true;
      this.setAttribute('aria-hidden', 'false');

      if (this._currentAnim) this._currentAnim.cancel();
      this._currentAnim = this.animate(
        [
          { transform: 'translateY(100%)', opacity: 0 },
          { transform: 'translateY(0%)', opacity: 1 }
        ],
        {
          duration: 550,
          easing: 'cubic-bezier(0.16, 1, 0.3, 1)',
          fill: 'forwards'
        }
      );

      // Defer to avoid catching this same click on the document listener
      setTimeout(() => document.addEventListener('click', this._onDocumentClick), 0);
    }

    close() {
      if (!this._isOpen) return;
      this._isOpen = false;
      this.setAttribute('aria-hidden', 'true');
      document.removeEventListener('click', this._onDocumentClick);

      if (this._currentAnim) this._currentAnim.cancel();
      this._currentAnim = this.animate(
        [
          { transform: 'translateY(0%)', opacity: 1 },
          { transform: 'translateY(100%)', opacity: 0 }
        ],
        {
          duration: 300,
          easing: 'ease-in',
          fill: 'forwards'
        }
      );
    }

    disconnectedCallback() {
      this._trigger?.removeEventListener('click', this._onTriggerClick);
      this._closeBtn?.removeEventListener('click', this._onCloseClick);
      document.removeEventListener('click', this._onDocumentClick);
      if (this._currentAnim) this._currentAnim.cancel();
    }
  });
}
